const fields = [
  {
    key: 'name',
    label: 'Nama',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    sortable: true,
  },
  {
    key: 'phone',
    label: 'No. HP',
    thClass: 'font-bold',
    class: 'align-middle text-black',
  },
  {
    key: 'address',
    label: 'Lokasi',
    thClass: 'font-bold',
    class: 'align-middle text-black',
  },
]

const fieldsMeta = [
  {
    key: 'name',
    label: 'Nama',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    sortable: true,
  },
  {
    key: 'phone',
    label: 'No. HP',
    thClass: 'font-bold',
    class: 'align-middle text-black',
  },
]

const linkImport = {
  google: 'https://storage.googleapis.com/komerce/assets/LP-Komchat/google-icon.svg',
  komship: 'https://storage.googleapis.com/komerce/assets/LP-Komerce/komship.svg',
  komchat_ai: 'https://storage.googleapis.com/komerce/assets/LP-Komerce/komchat.svg',
  komchat_meta: 'https://storage.googleapis.com/komerce/LP-Advertiser/icons-meta.svg',
}

const filterImportMeta = [
  {
    label: 'Tanggal',
    key: 'tanggal',
    options: [],
  },
  {
    label: 'Tingkat Interaksi',
    key: 'interaction_level',
    options: [
      { id: 'high', name: 'Tinggi' },
      { id: 'low', name: 'Rendah' },
    ],
  },
]

export {
  fields, fieldsMeta, linkImport, filterImportMeta,
}
